import storage from "../Persistence/Storage";

const CACHE_VALID_TIME = 30 * 1000;
export const IGNORE_CDN_CACHE_TIME = "ignore-cdn-cache-time";
export const IGNORE_CDN_CACHE_REASON = "ignore-cdn-cache-reason";

export function prepareSearchCriteria(
    criteria: Record<string, unknown> | undefined,
): string {
    const lastActionAt = shouldIgnoreApiCacheTime();
    const cacheBusterReason = storage.getItem(IGNORE_CDN_CACHE_REASON) || "";
    const cacheBuster = lastActionAt
        ? { upd: lastActionAt, udpWhy: cacheBusterReason }
        : {};

    const entries = Object.entries({ ...criteria, ...cacheBuster });

    if (!entries.length) {
        return "";
    }

    return (
        "?" +
        entries
            .filter(([, value]) => value !== undefined)
            .map(([key, value]) => `${key}=${value}`)
            .join("&")
    );
}

export function prepareSearchCriteriaWithoutCaching(
    criteria: Record<string, unknown> | undefined,
): string {
    const entries = Object.entries(criteria || {});

    if (!entries.length) {
        return "";
    }

    return (
        "?" +
        entries
            .filter(([, value]) => value !== undefined)
            .map(([key, value]) => `${key}=${value}`)
            .join("&")
    );
}

export enum RESET_API_CACHE_REASONS {
    COMMENT_REPORT = "COMMENT_REPORT",
    COMMENT_DELETE = "COMMENT_DELETE",
    COMMENT_CREATE_OR_UPDATE = "COMMENT_CREATE_OR_UPDATE",
    POST_CREATE_OR_UPDATE = "POST_CREATE_OR_UPDATE",
    POST_REPORT = "POST_REPORT",
    POST_DELETE = "POST_DELETE",
    POST_POLL_VOTE = "POST_POLL_VOTE",
    REACT_ON_POST = "REACT_ON_POST",
    REACT_ON_COMMENT = "REACT_ON_COMMENT",
    REACT_ON_PREVIEW_COMMENT = "REACT_ON_PREVIEW_COMMENT",
    REACT_ON_PINNED_COMMENT = "REACT_ON_PINNED_COMMENT",
}

export function resetIgnoreApiCacheTime(
    reasonToReset: RESET_API_CACHE_REASONS,
) {
    const date = new Date();
    storage.setItem(IGNORE_CDN_CACHE_TIME, date.getTime().toString());
    storage.setItem(IGNORE_CDN_CACHE_REASON, reasonToReset);
}

function shouldIgnoreApiCacheTime() {
    const lastActionAt = storage.getItem(IGNORE_CDN_CACHE_TIME) || "0";
    const date = new Date();

    if (date.getTime() <= parseInt(lastActionAt) + CACHE_VALID_TIME) {
        return lastActionAt;
    }

    return null;
}
